import React from 'react';
import {PhotoSwipeGallery} from 'react-photoswipe';


class PhotoAlbum extends React.Component{
    state = {
        isOpen: false,
        options:{
            history:false,
            showHideOpacity:true,
            shareEl:true,
            fullscreenEl: false,
            loop:false,
        },
        
    };
    handelBcolor = () =>{
        const slide = document.getElementsByClassName('pswp__counter')[0].innerText;
        const item = slide.substr(0, slide.indexOf(' / '));
        const itemBcolor = document.getElementById('galleryImage'+item).getAttribute('bcolor');
        console.log("itemBcolor " + itemBcolor);
        this.refs.gallaryWarp.id = itemBcolor;
    }
    getThumbnailContent = (item) => {         
        return (
            <div className="col-sm-4">
                <div className="cover" style={{backgroundImage: `url(${item.thumbnail})`}}>
                  <img id={`galleryImage${item.id}`} src={item.thumbnail} bcolor={/*item.color*/"pink"} />  
                </div>
            </div>
        );
    };

  render(){
    return(
            <div className="photoAlbum">
                <div className="title">
                    <p dangerouslySetInnerHTML={{__html: "What we did for " + this.props.title}}/>
                </div>
                <div className="content">
                    <div className="row">
                        <div ref="gallaryWarp" id="">
                            <PhotoSwipeGallery ref="pswp" id={this.props.id} items={this.props.gallery}
                            thumbnailContent={this.getThumbnailContent} afterChange={this.handelBcolor} options={this.state.options}>
                            </PhotoSwipeGallery>
                        </div>
                    </div>
                </div>
            </div>
    );
  }
}


export default PhotoAlbum;



// WEBPACK FOOTER //
// ./src/components/PhotoAlbum.js